import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Flex, Text, Card, Heading, Grid, DataList, Button, Separator } from '@radix-ui/themes';
import UserAvatar from '../common/UserAvatar';
import GeneralInfo from '../forms/general/GeneralInfo';
import StudentSchoolProfile from '../profile/student/StudentSchoolProfile';
import LinkGuardian from '../forms/student/LinkGuardian';
import ProfilePictureForm from '../forms/ProfilePictureForm';

const StudentProfile = () => {
    const user = useSelector((state) => state.user.details);

    return (
        <Box width="100%" maxWidth="1080px">
            <Grid columns="4" gapX="8" gapY="4">
                <Box gridColumnStart="1" gridColumnEnd="5" gridRowStart="1">
                    <ProfilePictureForm user={user} size="8" />
                </Box>
                <Flex direction="column" gap="4" align="start" gridColumnStart={{initial: 1, md: 1}} gridColumnEnd={{initial: 5, md: 3}} gridRowStart="2">
                    <GeneralInfo />
                    <Separator size="4" />
                    <LinkGuardian />
                    <Separator size="4"/>
                </Flex>
            
                <Flex direction="column" gap="4" align="start" gridColumnStart={{initial: 1, md: 3}} gridColumnEnd={{initial: 5, md: 5}} gridRowStart={{initial: 3, md: 2}}>
                    <StudentSchoolProfile />
                </Flex>

                {/* <Box gridColumnStart="1" gridColumnEnd="13">
                    <Card>
                        <Flex direction="column" gap="4">
                            <Flex direction="row" gap="4" align="center">
                                
                                <Flex direction="column" gap="1">
                                    <Heading size="4">{user.firstname} {user.lastname}</Heading>
                                    <Text size="2" color="gray">{user.email ?? 'N/A'}</Text>
                                </Flex>
                            </Flex>
                        </Flex>
                    </Card>
                </Box> */}
            </Grid>
        </Box>
    );
};

export default StudentProfile;
